import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import styled, { css } from "styled-components";
import { Config } from "../constant";
import {
  getChatRoomId,
  getConnectionId,
  send,
  sendWithSession,
  StartTimerForTimeout,
} from "../Socket";
import { observer } from "mobx-react";
import Flag from "../assets/Flag.png";
import "../index.css";
import CaptchaField from "./CaptchaField";
import { CustomerInitiatesChat } from "../model/Outgoing";
import Axios from "axios";
import * as yup from "yup";
import "yup-phone";
import {
  CommonStore,
  EnableCreateSession,
  SendingInitRoom,
  SetActiveEntryPointId,
  SetIdPel,
  UpdateFirstMessage,
} from "../Store";
import CloseToolbar from "../module-common/CloseToolbar";
import qs from "qs";
import InputWithLabel from "./InputWithLabel";
import { getYupValidation } from "./validations";
import { LogAgentRequest } from "./LogAgentRequest";

const customInputStyle = {
  borderBottom: "none",
  marginBottom: "3px",
};

export default observer(
  class FormBody extends Component {
    constructor(props) {
      super(props);
    }

    state = {
      error: undefined,
      name: "",
      email: "",
      phoneNumber: "",
      isSessionActive: false,
      counterName: 0,
      counterEmail: 0,
      counterPhonenumber: 0,
      counterSubject: 0,
      chatSubjectList: [],
      selectedSubject: null,
      captchaId: null,
      captchaAnswer: "",
      customFields: [],
      customFieldsAnswer: {},
      inputError: null,
      enableCaptcha: false,
      yupValidator: null,
      yourMessage: "",
      counterYourMessage: 0,
      subjectLoading: false,
      chatOrigin: null,
    };

    async logAgentRequest(found) {
      const logUri = Config.agentRequestLogUri;
      const { name, email, phoneNumber, customFieldsAnswer } = this.state;
      const result = await Axios.post(logUri, {
        entryPoint: found.entryPointId,
        connectionId: getConnectionId(),
        name,
        email,
        idPel: customFieldsAnswer.idpel,
        phoneNumber,
      });
    }

    async loadChatSubjectOnly(id) {
      const endpoint = Config.chatSettingUrl;
      this.setState((state) => ({ ...state, subjectLoading: true }));
      let found = null;
      try {
        const result = await Axios.get(endpoint);
        const { subjects } = result.data;
        found = subjects.find((item) => item.id == id);
        if (found && !found.isAgentAvailable) {
          await LogAgentRequest(this.state, found);
        }
      } catch (e) {
        this.setState((state) => ({ ...state, subjectLoading: false }));
      }
      return found;
    }

    async loadChatSettings() {
      try {
        const endpoint = Config.chatSettingUrl;
        const result = await Axios.get(endpoint);
        const { subjects, custom_fields, captcha } = result.data;
        const customFieldsAnswer = custom_fields.reduce((memo, item) => {
          memo[item.name] = null;
          return memo;
        }, {});
        console.log(customFieldsAnswer);
        const validationConfig = getYupValidation(custom_fields);
        const validation = yup.object().shape(validationConfig);
        this.setState((state) => ({
          ...state,
          chatSubjectList: subjects,
          customFields: custom_fields,
          customFieldsAnswer,
          enableCaptcha: captcha ? captcha.enable : false,
          yupValidator: validation,
        }));
      } catch (e) {
        console.log("Error on fetching subject list", e);
      }
    }

    updateCustomFieldAnswer = (name, value) => {
      this.setState((state) => {
        if (value) {
          state.customFieldsAnswer[name] = value;
        } else delete state.customFieldsAnswer[name];
        return state;
      });
    };

    async componentDidMount() {
      await this.loadChatSettings();
      const queryParams = qs.parse(window.location.search, {
        ignoreQueryPrefix: true,
      });
      console.log(queryParams);
      const { referer, name, email, phone, isMobile } = queryParams;
      this.setState((state) => ({ ...state, origin: referer }));
      const eventMethod = window.addEventListener
        ? "addEventListener"
        : "attachEvent";
      const eventer = window[eventMethod];
      const messageEvent =
        eventMethod == "attachEvent" ? "onmessage" : "message";
      eventer(
        messageEvent,
        async (e) => {
          if (e.data) {
            if (e.data.type == "fillForm") {
              const { name, email, phoneNumber } = e.data.data;
              this.setState((state) => ({
                ...state,
                name,
                email,
                phoneNumber,
                counterName: name ? 1 : 0,
                counterEmail: email ? 1 : 0,
                counterPhonenumber: phoneNumber ? 1 : 0,
              }));
              try {
                const validated = await this.validateInput();
              } catch (e) {}
            }
          }
        },
        false
      );
      if (name || email || phone) {
        this.setState((state) => ({
          ...state,
          name,
          email,
          phoneNumber: phone,
          counterName: name ? 1 : 0,
          counterEmail: email ? 1 : 0,
          counterPhonenumber: phone ? 1 : 0,
        }));
        try {
          const validated = await this.validateInput();
        } catch (e) {}
      }
    }

    static propTypes = {
      name: PropTypes.string,
      email: PropTypes.string,
      phoneNumber: PropTypes.string,
      isActive: PropTypes.bool,
    };
    static defaultProps = {
      isActive: false,
    };

    isCaptchaOk = () => {
      const { captchaId, captchaAnswer, enableCaptcha } = this.state;
      if (!enableCaptcha) return true;
      return captchaId && captchaAnswer;
    };

    isCustomFieldOk = () => {
      const { customFieldsAnswer } = this.state;
      const hasNotAnswered = Object.values(customFieldsAnswer).find(
        (item) => !item
      );
      return !hasNotAnswered;
    };

    isOkToSubmit = () => {
      if (this.state.chatSubjectList.length < 0) return;
      const {
        counterName,
        counterEmail,
        counterPhonenumber,
        counterSubject,
        counterYourMessage,
      } = this.state;
      console.log(this.state);
      return (
        counterName +
          counterEmail +
          counterPhonenumber +
          counterSubject +
          counterYourMessage ===
          5 &&
        this.isCaptchaOk() &&
        this.isCustomFieldOk()
      );
    };

    validateInput = async () => {
      const {
        name,
        email,
        phoneNumber,
        customFieldsAnswer,
        selectedSubject,
        yupValidator,
        yourMessage,
      } = this.state;
      if (!yupValidator) return false;
      const input = {
        chatSubject: selectedSubject ? selectedSubject.id : undefined,
        name,
        email,
        phoneNumber,
        idpel: customFieldsAnswer.idpel,
        yourMessage,
      };
      console.log("Validate", input);
      return await yupValidator.validate(input, {
        abortEarly: false,
      });
    };

    onSubmit = async () => {
      if (!CommonStore.isInitiatingRoom) {
        try {
          this.setState((state) => ({ ...state, inputError: null }));
          const validated = await this.validateInput();
          let customFieldsAnswer = this.state.customFieldsAnswer;
          Object.keys(customFieldsAnswer).forEach((key) => {
            if (!customFieldsAnswer[key]) {
              delete customFieldsAnswer[key];
            }
          });
          const message = CustomerInitiatesChat(
            this.state.name,
            this.state.email,
            "62" + this.state.phoneNumber,
            this.state.selectedSubject,
            this.state.captchaId,
            this.state.captchaAnswer,
            customFieldsAnswer,
            this.state.origin
          );
          this.setState((state) => ({ ...state, isSubmitting: true }));
          UpdateFirstMessage(this.state.yourMessage);
          SendingInitRoom();
          EnableCreateSession();
          StartTimerForTimeout(new Date().getTime());
          SetActiveEntryPointId(this.state.selectedSubject.entryPointId);
          SetIdPel(customFieldsAnswer.idpel);
          sendWithSession(message);
        } catch (e) {
          const { inner, value } = JSON.parse(JSON.stringify(e));
          console.log(inner);
          const error = inner.reduce((memo, item) => {
            memo[item.path] = item.message;
            return memo;
          }, {});
          this.setState((state) => ({ ...state, inputError: error }));
        }
      }
    };
    render() {
      const { displayPicture, onClose } = this.props;
      const {
        chatSubjectList,
        customFields,
        customFieldsAnswer,
        inputError,
        enableCaptcha,
        selectedSubject,
      } = this.state;
      const isAgentAvailable = selectedSubject
        ? selectedSubject.isAgentAvailable
        : false;
      const initTimeoutReason = CommonStore.disableCreateSessionReason;
      return (
        <Screen className="form-body">
          <Wrapper>
            <CloseToolbar
              onClose={onClose}
              style={{ position: "absolute", right: 0, top: 10 }}
            />
            <LogoWrapper>
              <Logo alt="logochat" src={displayPicture} />
            </LogoWrapper>
            <TextWrapper>
              <Text>
                Thanks for contacting us. Please complete this form and{" "}
                <b>Start Chat.</b>
                {initTimeoutReason ? (
                  <div style={{ color: "red" }}>{initTimeoutReason}</div>
                ) : null}
              </Text>
            </TextWrapper>

            <Panel>
              <div>
                <Label>Subject</Label>
                {inputError ? (
                  inputError.chatSubject ? (
                    <ErrorLabel>{inputError.chatSubject}</ErrorLabel>
                  ) : null
                ) : null}
              </div>
              <Select
                onChange={async (ev) => {
                  const value = ev.target.value;
                  let isValidSelection = false;
                  let found = null;
                  try {
                    if (value) {
                      found = await this.loadChatSubjectOnly(value);
                      console.log("Result from api", found);
                    }
                  } catch (e) {
                    console.log("Error on reloading chat subject..");
                    found = chatSubjectList.find((item) => item.id == value);
                  }
                  if (found) {
                    isValidSelection = true;
                    this.setState((state) => ({
                      ...state,
                      selectedSubject: found,
                      counterSubject: 1,
                    }));
                  }
                  if (!isValidSelection) {
                    this.setState((state) => ({
                      ...state,
                      selectedSubject: null,
                      counterSubject: 0,
                    }));
                  }
                }}
              >
                <option>Please select chat subject</option>
                {chatSubjectList.map((element) => {
                  return (
                    <option key={element.id} value={element.id}>
                      {element.title}
                    </option>
                  );
                })}
              </Select>
              {selectedSubject && !isAgentAvailable && (
                <TextWrapper>
                  <Text bolder={true} warning>
                    It seems all agents are busy right now. Please try a while
                    later
                  </Text>
                </TextWrapper>
              )}
              {selectedSubject && isAgentAvailable && (
                <Fragment>
                  <InputWithLabel
                    label="Your name"
                    name="name"
                    value={this.state.name}
                    errorMessage={inputError ? inputError.name : null}
                    onChange={(e) => {
                      if (e.target.value.length === 0) {
                        this.setState({ counterName: 0 });
                      } else {
                        this.setState({ counterName: 1 });
                      }
                      this.setState({ name: e.target.value, counterName: 1 });
                    }}
                  />
                  <InputWithLabel
                    label="Email"
                    name="email"
                    value={this.state.email}
                    errorMessage={inputError ? inputError.email : null}
                    onChange={(e) => {
                      if (e.target.value.length === 0) {
                        this.setState({ counterEmail: 0 });
                      } else {
                        this.setState({ counterEmail: 1 });
                      }
                      this.setState({ email: e.target.value });
                    }}
                  />
                  <div>
                    <Label>Phone Number</Label>
                    {inputError ? (
                      inputError.phoneNumber ? (
                        <ErrorLabel>{inputError.phoneNumber}</ErrorLabel>
                      ) : null
                    ) : null}
                  </div>
                  <PhoneNumberWrapper>
                    <DropDownWrapper>
                      <FlagWrapper alt="bendera indonesia" src={Flag} />
                      <DropDownText>+62</DropDownText>
                    </DropDownWrapper>
                    <InputPhoneNumber>
                      {" "}
                      <Input
                        label="Phone Number"
                        type="number"
                        name="phonenumber"
                        min="0"
                        inputMode="numeric"
                        pattern="[0-9]*"
                        phoneNumber={this.props.phoneNumber}
                        value={this.state.phoneNumber}
                        style={customInputStyle}
                        placeholder="Your Phone Number"
                        onChange={(e) => {
                          if (e.target.value.length === 0) {
                            this.setState({ counterPhonenumber: 0 });
                          } else {
                            this.setState({ counterPhonenumber: 1 });
                          }
                          this.setState({ phoneNumber: e.target.value });
                        }}
                      />
                    </InputPhoneNumber>
                  </PhoneNumberWrapper>
                  {customFields.map((item) => (
                    <Fragment>
                      <InputWithLabel
                        label={item.label}
                        name={item.name}
                        errorMessage={inputError ? inputError[item.name] : null}
                        value={customFieldsAnswer[item.name]}
                        onChange={(e) => {
                          this.updateCustomFieldAnswer(
                            item.name,
                            e.target.value
                          );
                        }}
                      />
                    </Fragment>
                  ))}
                  {enableCaptcha && (
                    <CaptchaField
                      onIdChange={(id) => {
                        this.setState({ captchaId: id, captchaAnswer: "" });
                      }}
                    >
                      <Input
                        label="Captcha Answer"
                        name="captcha_asnwer"
                        value={this.state.captchaAnswer}
                        type="email"
                        placeholder="Captcha answer"
                        onChange={(e) => {
                          this.setState({ captchaAnswer: e.target.value });
                        }}
                      />
                    </CaptchaField>
                  )}
                  <InputWithLabel
                    textarea
                    label="Your message"
                    name="yourMessage"
                    value={this.state.yourMessage}
                    errorMessage={inputError ? inputError.yourMessage : null}
                    onChange={(e) => {
                      if (e.target.value.length === 0) {
                        this.setState({ counterYourMessage: 0 });
                      } else {
                        this.setState({ counterYourMessage: 1 });
                      }
                      this.setState({
                        yourMessage: e.target.value,
                        counterYourMessage: 1,
                      });
                    }}
                  />
                  <SubmitButton>
                    <Submit
                      type="Submit"
                      onClick={(e) => {
                        console.log("Hai");
                        if (!this.isOkToSubmit()) return;
                        else this.onSubmit();
                      }}
                      isActive={this.isOkToSubmit()}
                    >
                      {CommonStore.isInitiatingRoom ? "Sending" : "Start Chat"}
                    </Submit>
                  </SubmitButton>
                </Fragment>
              )}
            </Panel>
          </Wrapper>
        </Screen>
      );
    }
  }
);

const Screen = styled.div`
  position: absolute;
  right: 0px;
  bottom: 0px;
  border-radius: 5px;
  background: linear-gradient(90deg, #2db7a2, #35adac, #4e8ec8);
  border-radius: 5px;
  box-shadow: 2px 2px 20px rgba(0, 0, 0, 0.2);
  width: 350px;
  height: 750px;

  @media (max-width: 600px) {
    position: absolute;
    right: 0px;
    bottom: 0px;
    border-radius: 5px;
    background: linear-gradient(90deg, #2db7a2, #35adac, #4e8ec8);
    border-radius: 5px;
    box-shadow: 2px 2px 20px rgba(0, 0, 0, 0.2);
    width: 100%;
    height: 100%;
    overflow: auto;
  }
  @media (max-height: 400px) {
    position: absolute;
    right: 0px;
    bottom: 0px;
    border-radius: 5px;
    background: linear-gradient(90deg, #2db7a2, #35adac, #4e8ec8);
    border-radius: 5px;
    box-shadow: 2px 2px 20px rgba(0, 0, 0, 0.2);
    width: 100%;
    height: 100%;
  }
`;
const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
`;
const LogoWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 10%;
  width: 100%;

  @media (max-width: 430px) {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 25%;
    width: 100%;
    margin: 15px 0 10px 0;
  }
`;
const Logo = styled.img`
  width: auto;
  height: 75%;
  @media (max-width: 430px) {
    width: auto;
    height: 75px;
  }
`;
const TextWrapper = styled.div`
  display: flex;
  box-sizing: border-box;
  margin: 0 7% 0 7%;
`;

const Text = styled.div`
  font-size: 0.8em;
  color: white;
  text-align: justify;
  line-height: 1.5;
  font-family: "Source Sans Pro", sans-serif;
  ${(props) =>
    props.bolder &&
    css`
      font-weight: bolder;
    `}
  ${(props) =>
    props.warning &&
    css`
      color: yellow;
    `}
  @media (max-width: 460px) {
    font-size: 0.7em;
    color: white;
    text-align: justify;
    line-height: 1.5;
    font-family: "Source Sans Pro", sans-serif;
  }
`;
const Panel = styled.div`
  display: flex;
  flex-direction: column;
  margin: 2% 7% 9% 7%;
  width: auto;
  height: auto;
`;

const Select = styled.select`
  background-color: transparent;
  border: 0px;
  border-bottom: solid 2px white;
  margin-bottom: 10px;
  padding: 3px;
  font-size: 0.7em;
  line-height: 1.5;
  font-family: "Source Sans Pro", sans-serif;
  ::placeholder {
    color: white;
    opacity: 0.3364;
  }
  &:focus {
    font-weight: bold;
    outline: none;
  }
`;

const Label = styled.label`
  color: white;
  margin: 0 0 5px 0;
  font-size: 0.75em;
  font-family: "Source Sans Pro", sans-serif;
  @media (max-width: 430px) {
    color: white;
    margin: 0 0 2% 0;
    font-family: "Source Sans Pro", sans-serif;
  }
`;

const ErrorLabel = styled.span`
  color: red;
  margin: 0 0 5px 0;
  text-align: right;
  font-size: 0.75em;
  font-family: "Source Sans Pro", sans-serif;
  float: right;
`;

const Input = styled.input`
  background-color: transparent;
  border: 0px;
  border-bottom: solid 2px white;
  margin-bottom: 10px;
  padding: 3px;
  color: #ffffff;
  font-size: 0.7em;
  line-height: 1.5;
  font-family: "Source Sans Pro", sans-serif;
  ::placeholder {
    color: white;
    opacity: 0.3364;
  }
  &:focus {
    font-weight: bold;
    outline: none;
  }
`;

const PhoneNumberWrapper = styled.div`
  display: flex;
  flex-direction: row;
  border-bottom: solid 2px white;
  margin-bottom: 10px;
`;
const DropDownWrapper = styled.div`
  display: flex;
  flex-direction: row;
  width: 20%;
  justify-content: center;
  border-right: solid 2px white;
  margin: 1% 1% 2% 0;
  padding-right: 1%;
  line-height: 3;
`;
const FlagWrapper = styled.img`
  display: flex;
  margin-right: 4px;
  height: 10.53px;
  width: 16.33px;
  align-self: center;
  @media (max-width: 320.98px) {
    display: flex;
    margin-right: 4px;
    height: 8.48px;
    width: 14.87px;
    align-self: center;
  }
  @media (max-width: 410px) {
    display: flex;
    margin-right: 4px;
    height: 9.5px;
    width: 15.5px;
    align-self: center;
  }
  @media (max-width: 520.98px) {
    display: flex;
    margin-right: 4px;
    height: 9.69px;
    width: 15.97px;
    align-self: center;
  }
  @media (max-width: 800.98px) {
    display: flex;
    margin-right: 4px;
    height: 10.23px;
    width: 16.2px;
    align-self: center;
  }
`;

const InputPhoneNumber = styled.div`
  display: flex;
  width: 80%;
  margin-left: 3px;
  align-items: flex-end;
`;

const DropDownText = styled.span`
  color: #ffffff;
  font-size: 0.75em;
  line-height: 1.5;
  font-family: "Source Sans Pro", sans-serif;
  @media (max-width: 320.98px) {
    color: #ffffff;
    font-size: 0.65em;
    line-height: 1.5;
    font-family: "Source Sans Pro", sans-serif;
  }
  @media (max-width: 410px) {
    color: #ffffff;
    font-size: 0.675em;
    line-height: 1.5;
    font-family: "Source Sans Pro", sans-serif;
  }
  @media (max-width: 520.98px) {
    color: #ffffff;
    font-size: 0.7em;
    line-height: 1.5;
    font-family: "Source Sans Pro", sans-serif;
  }
  @media (max-width: 800.98px) {
    color: #ffffff;
    font-size: 0.725em;
    line-height: 1.5;
    font-family: "Source Sans Pro", sans-serif;
  }
`;

const SubmitButton = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 25px;
`;

const Submit = styled.button`
  font-size: 0.7em;
  align-content: center;
  align-self: center;
  padding: 8px 15px 8px 15px;
  border: none;
  border-radius: 14px;
  margin-top: -10px;
  font-family: "Source Sans Pro", sans-serif;
  ${(props) =>
    !props.isActive &&
    css`
      background: #bababa;
      color: #9f9f9f;
    `};
  ${(props) =>
    props.isActive &&
    css`
      color: #6bbcf4;
      background: white;
    `};
`;
